module.exports = __webpack_public_path__ + "img/Lb.e337f892.png";